import React, { useEffect, useState } from 'react';
import { Box, CircularProgress, Stack, Typography } from '@mui/material';
import { Navigate, useParams } from 'react-router-dom';
import { doc, getDoc } from 'firebase/firestore';
import { db } from '../firebase';
import RecordingDetails from './RecordingDetails';

const RecordingDetailsRoute = () => {
  const { docId = '' } = useParams();
  const decodedDocId = decodeURIComponent(docId);
  const [redirectToAgent, setRedirectToAgent] = useState('');
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    let isMounted = true;

    const checkRecordingType = async () => {
      try {
        const snapshot = await getDoc(doc(db, 'recordings', decodedDocId));
        const data = snapshot.exists() ? (snapshot.data() || {}) : null;
        const resolvedAgentId = data?.metadata?.agentId || '';

        if (isMounted && data?.source === 'agent' && resolvedAgentId) {
          setRedirectToAgent(`/ai-agents/${resolvedAgentId}/conversations/${encodeURIComponent(decodedDocId)}`);
        }
      } catch (error) {
        console.error('Error checking recording type:', error);
      } finally {
        if (isMounted) {
          setChecking(false);
        }
      }
    };

    checkRecordingType();

    return () => {
      isMounted = false;
    };
  }, [decodedDocId]);

  if (redirectToAgent) {
    return <Navigate to={redirectToAgent} replace />;
  }

  if (checking) {
    return (
      <Box sx={{ minHeight: 320, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <Stack spacing={2} alignItems="center">
          <CircularProgress size={40} />
          <Typography color="text.secondary">Բեռնվում է…</Typography>
        </Stack>
      </Box>
    );
  }

  return <RecordingDetails />;
};

export default RecordingDetailsRoute;
